import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const FUNNEL_STAGES = [
  { key: "sent",      metric: "sent_cohort",       labelKey: "dashboard.stage_sent",      countKey: "sent_count" },
  { key: "opened",    metric: "opened_cohort",     labelKey: "dashboard.stage_opened",    countKey: "opened_count" },
  { key: "responded", metric: "responded_cohort",  labelKey: "dashboard.stage_responded", countKey: "responded_count" },
  { key: "accepted",  metric: "accepted_cohort",   labelKey: "dashboard.stage_accepted",  countKey: "accepted_count" },
];

export default function DashboardFunnel({ stages, onSegmentClick }) {
  const { t } = useTranslation();
  const total = Math.max(1, stages?.sent_count || 0);

  const rows = useMemo(
    () =>
      FUNNEL_STAGES.map((s) => {
        const value = stages?.[s.countKey] || 0;
        const width = Math.max(2, Math.round((value / total) * 100));
        const pct = stages?.sent_count ? ((value / stages.sent_count) * 100).toFixed(1) : "0.0";
        return { ...s, value, width, pct };
      }),
    [stages, total],
  );

  return (
    <div className="qw-funnel" data-testid="dashboard-funnel">
      {rows.map((r) => (
        <div
          key={r.key}
          className={`row clickable stage-${r.key}`}
          role="button"
          tabIndex={0}
          data-testid={`funnel-row-${r.key}`}
          onClick={() => onSegmentClick(r.metric)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSegmentClick(r.metric);
            }
          }}
        >
          <div className="stage">{t(r.labelKey)}</div>
          <div className="bar-wrap">
            <div className="bar" style={{ width: `${r.width}%` }} />
          </div>
          <div className="val">
            {r.value.toLocaleString("bg-BG")}
            <span className="pct">({r.pct}%)</span>
          </div>
        </div>
      ))}
    </div>
  );
}
